export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/error-500.485cdef5.svg","height":195,"width":402};